import React, { useContext, useEffect, useState } from "react";
import "../css/table_pagination.css";
import { act } from "react";


export function PaginationComponent({ pageCount, activePage, setActivePage }) {

    var shownStart = activePage - howManyCanFitLeft(activePage, 2)
    var usePages = pageCount >= 5 ? 4 - (activePage - shownStart) : pageCount - 1 - (activePage - shownStart)
    var shownEnd = activePage + howManyCanFitRight(activePage, pageCount - 1 , usePages)
    usePages -= howManyCanFitRight(activePage, pageCount -1 , usePages)
    if (usePages > 0 )
        shownStart -=howManyCanFitLeft(activePage, usePages)


    function onPressPrev() {
        if (activePage > 0) {
            setActivePage(activePage - 1);
        }else{
            setActivePage(pageCount - 1)
        }
    }

    function onPressNext() {
        if (activePage < pageCount - 1) {
            setActivePage(activePage + 1);
        }else{
            setActivePage(0)
        }
    }

    const pageButtons = []
    for (let i = shownStart; i <= shownEnd; i++) {
        pageButtons.push(
            <li key={i}>
                <PaginationButton label={`${i + 1}`} active={i === activePage} onPressFunction={() => { setActivePage(i) }} />
            </li>
        )
    }
    return (
        <>
            <nav className="pagination-container">
                <div className="pagination-jump">
                    <PaginationButton label="<<" onPressFunction={()=>{setActivePage(0)}}/>
                    <PaginationButton label="<" onPressFunction={onPressPrev} />
                </div>
                <ul className="pagination-items">
                    {
                        pageButtons
                    }
                    {
                        shownEnd <  pageCount && <li className="pag-dots"> ...</li> 
                    }

                </ul>
                <div className="pagination-jump">
                    <PaginationButton label=">" onPressFunction={onPressNext} />
                    <PaginationButton label=">>" onPressFunction={()=>{setActivePage(pageCount-1)}}/>
                </div>
            </nav>

        </>
    );
}

function PaginationButton({ label, active, onPressFunction }) {
    return (
        <button
            className={`pagination-button ${active ? "active" : ""}`}
            aria-current={active ? "page" : undefined}
            onClick={onPressFunction}
        >
            {label}
        </button>
    );
}


function howManyCanFitLeft(active_index, want_to_fit = 2){
    if(active_index  >= want_to_fit)
        return want_to_fit
    return active_index
}

function howManyCanFitRight(active_index, page_count,  want_to_fit = 2){
    if((page_count - active_index ) >= want_to_fit)
        return want_to_fit
    return (page_count - active_index)
}